import React, { Component } from 'react'
import './LoginPopup.scss'
import Axios from 'axios'
import config from '../Shared/config'
import Token from '../Utils/Token'
import moment from 'moment'

export default class LoginPopup extends Component {
    constructor(props) {
        super(props)

        this.state = {
            show: false,
            loginActive: true,
            signUpData: {},
            signUpErrors: {},
            objectId: '',
            showOtpForm: false,
            otp: '',
            loginData: {},
            loginErrors: {},
            waitingForRequestOTPCall: false,
            waitingForSignupCall: false,
            otpRemainingSeconds: 0
        }
    }

    hidePopup = () => {
        this.setState({
            show: false,
            loginActive: true,
            signUpData: {},
            signUpErrors: {},
            objectId: '',
            showOtpForm: false,
            otp: '',
            loginData: {},
            loginErrors: {}
        }, this.props.toggleBodyScrolling(false))
    }

    toggleMode = (val) => {
        this.setState({ loginActive: val })
    }

    startOTPCountdown = () => {
        // Starting countdown for otp validity
        let currentDate = moment().add(120, 's').toDate();
        let countDownDate = currentDate.getTime();

        const stateChanger = (state) => {
            this.setState(state)
        }

        // Update the count down every 1 second
        let x = setInterval(function () {

            // Get today's date and time
            let now = new Date().getTime();

            // Find the distance between now and the count down date
            let distance = countDownDate - now;

            // Time calculations for seconds
            let seconds = Math.floor((distance / 1000));

            // Output the result in an element with id="demo"
            stateChanger({
                otpRemainingSeconds: seconds
            })

            // If the count down is over, write some text 
            if (distance < 0) {
                clearInterval(x);
            }
        }, 1000);
    }

    onClickRequestOTP = (resend) => {
        let validationResult = this.validateSignupForm()
        if (resend || validationResult.valid) {
            if (resend || document.getElementById('termsAndConditions').checked) {
                this.setState({
                    waitingForRequestOTPCall: true
                })
                const url = config.apiUrl + '/Authentication/generateOTP'
                const data = this.state.signUpData
                Axios.post(url, data).then(res => {
                    if (!res.data.error) {
                        this.setState({
                            objectId: res.data.data[`_id`],
                            showOtpForm: true,
                            waitingForRequestOTPCall: false
                        }, () => {
                            this.startOTPCountdown()
                        })
                    } else {
                        this.setState({
                            waitingForRequestOTPCall: false
                        })
                        alert(res.data.message)
                    }
                }).catch(err => {
                    this.setState({
                        waitingForRequestOTPCall: false
                    })
                    console.log(err)
                })
            } else {
                alert('Please accept terms and conditions to continue.')
            }
        } else {
            let invalidMessage = ''
            for (let field in validationResult.validationData) {
                if (validationResult.validationData[field].haveError) {
                    invalidMessage = `${invalidMessage}${validationResult.validationData[field].errorMessage}\n`
                }
            }
            alert(invalidMessage)
        }
    }

    validateSignupForm = () => {
        let { signUpData, signUpErrors } = this.state
        let valid = true

        let val = signUpData.firstName
        if (val && val.length > 0) {
            signUpErrors.firstName = {
                haveError: false,
                errorMessage: null
            }
        } else {
            signUpErrors.firstName = {
                haveError: true,
                errorMessage: 'First Name is required.'
            }
        }

        val = signUpData.lastName
        if (val && val.length > 0) {
            signUpErrors.lastName = {
                haveError: false,
                errorMessage: null
            }
        } else {
            signUpErrors.lastName = {
                haveError: true,
                errorMessage: 'Last Name is required.'
            }
        }

        val = signUpData.email
        if (val && val.length > 0) {
            signUpErrors.email = {
                haveError: false,
                errorMessage: null
            }
        } else {
            signUpErrors.email = {
                haveError: true,
                errorMessage: 'Email is required.'
            }
        }

        val = signUpData.contactNumber
        if (val && val.length > 0) {
            signUpErrors.contactNumber = {
                haveError: false,
                errorMessage: null
            }
        } else {
            signUpErrors.contactNumber = {
                haveError: true,
                errorMessage: 'Please fill Contact Number correctly.'
            }
        }

        val = signUpData.password
        if (val) {
            if (val.length > 5) {
                if (val.length <= 10) {
                    signUpErrors.password = {
                        haveError: false,
                        errorMessage: null
                    }
                } else {
                    signUpErrors.password = {
                        haveError: true,
                        errorMessage: 'Password should be maximum 10 characters long.',
                    }
                }
            } else {
                signUpErrors.password = {
                    haveError: true,
                    errorMessage: 'Password should be minimum 6 characters long.',
                }
            }
        } else {
            signUpErrors.password = {
                haveError: true,
                errorMessage: 'Password is required.'
            }
        }

        val = signUpData.areaOfInterest
        if (val && val.length > 0) {
            signUpErrors.areaOfInterest = {
                haveError: false,
                errorMessage: null
            }
        } else {
            signUpErrors.areaOfInterest = {
                haveError: true,
                errorMessage: 'Area of Interest is required.'
            }
        }

        // Basic check to see if anyfield is there in Error object or not
        for (let item in signUpErrors) {
            if (signUpErrors[item].haveError === true) {
                valid = false
            }
        }

        this.setState({ signUpErrors })

        return {
            valid: valid,
            validationData: signUpErrors
        }
    }

    onClickSignup = () => {
        if (this.state.otpRemainingSeconds < 0) {
            alert('OTP Expired. Please request OTP again.')
        } else {
            this.setState({
                waitingForSignupCall: true
            })

            let { 'signUpData': data, otp, objectId } = this.state;
            const url = config.apiUrl + '/Authentication/register'
            data.otp = otp;
            data.objectId = objectId;

            Axios.post(url, data).then(res => {
                if (res.data.error) {
                    alert(res.data.message)
                    this.setState({
                        waitingForSignupCall: false
                    })
                } else {
                    alert(res.data.message);
                    this.setState({
                        show: false,
                        loginActive: true,
                        signUpData: {},
                        loginData: {},
                        objectId: '',
                        showOtpForm: false,
                        otp: '',
                        waitingForSignupCall: false
                    })
                }
            }).catch(err => {
                console.log(err)
                this.setState({
                    waitingForSignupCall: false
                })
            })
        }
    }

    onChangeSignup = (e) => {
        let val = e.target.value;
        let state = this.state;
        state.signUpData[e.target.id] = val;

        if (state.signUpData[e.target.id] && state.signUpData[e.target.id].length > 0) {
            state.signUpErrors[e.target.id] = false
        } else {
            state.signUpErrors[e.target.id] = true
        }

        this.setState(state)
    }

    onBlurSignup = (e) => {
        let state = this.state;
        if (state.signUpData[e.target.id] && state.signUpData[e.target.id].length > 0) {
            state.signUpErrors[e.target.id] = false
        } else {
            state.signUpErrors[e.target.id] = true
        }
        this.setState(state)
    }

    onChangeOTP = (e) => {
        let val = e.target.value;
        let state = this.state;
        state.otp = val;
        this.setState(state)
    }

    onChangeLogin = (e) => {
        let val = e.target.value;
        let state = this.state;
        state.loginData[e.target.id] = val;
        this.setState(state)
    }

    onBlurLogin = (e) => {
        let state = this.state;
        if (state.loginData[e.target.id] && state.loginData[e.target.id].length > 0) {
            state.loginErrors[e.target.id] = false
        } else {
            state.loginErrors[e.target.id] = true
        }
        this.setState(state)
    }

    validateLoginForm = () => {
        let { loginData, loginErrors } = this.state
        let valid = true

        let val = loginData.email
        if (val && val.length > 0) {
            loginErrors.email = false
        } else {
            loginErrors.email = true
        }

        val = loginData.password
        if (val && val.length > 0) {
            loginErrors.password = false
        } else {
            loginErrors.password = true
        }

        // Basic check to see if anyfield is there in Error object or not
        for (let item in loginErrors) {
            if (loginErrors[item] === true) {
                valid = false
            }
        }

        this.setState({ loginErrors })

        return valid
    }

    onClickLogin = () => {
        let valid = this.validateLoginForm()
        if (valid) {
            let { 'loginData': data } = this.state;
            const url = config.apiUrl + '/Authentication/login'

            Axios.post(url, data).then(res => {
                if (res.data.error) {
                    alert(res.data.message)
                } else {
                    alert(res.data.message);
                    Token.setToken(res.data.data)
                    this.setState({
                        show: false,
                        loginActive: true,
                        signUpData: {},
                        loginData: {},
                        objectId: '',
                        showOtpForm: false,
                        otp: ''
                    })
                    window.location.reload();
                }
            }).catch(err => {
                console.log(err)
            })
        } else {
            alert('Please fill all the fields properly.')
        }
    }

    render() {
        const { show,
            loginActive,
            signUpData,
            showOtpForm,
            otp,
            loginData,
            signUpErrors,
            loginErrors,
            waitingForRequestOTPCall,
            waitingForSignupCall,
            otpRemainingSeconds
        } = this.state;

        return (
            <div className={`popup-container ${show ? 'active' : ''}`}>
                <div className={`popup ${loginActive ? 'login-active' : 'signup-active'}`}>

                    <div onClick={this.hidePopup} className="close-btn">
                        <img alt="close-btn" src={'https://image.flaticon.com/icons/svg/748/748122.svg'}></img>
                    </div>

                    <div className="left">

                        {
                            loginActive ? (
                                <div className="login-form">
                                    <div className="h1">Sign in to account</div>
                                    <div className="h2">or use your email to create new account</div>
                                    <div className="form">

                                        <div className='form-field-container'>
                                            <div title='Required' className='field-error'></div>
                                            <input
                                                onChange={this.onChangeLogin}
                                                onBlur={this.onBlurLogin}
                                                value={loginData['email'] || ''}
                                                className={`form-field ${loginErrors.email ? 'invalid' : ''}`}
                                                type="text"
                                                id="email"
                                                placeholder="Email" />
                                        </div>

                                        <div className='form-field-container'>
                                            <div title='Required' className='field-error'></div>
                                            <input
                                                onChange={this.onChangeLogin}
                                                onBlur={this.onBlurLogin}
                                                value={loginData['password'] || ''}
                                                className={`form-field ${loginErrors.password ? 'invalid' : ''}`}
                                                type="password"
                                                id="password"
                                                placeholder="Password" />
                                        </div>

                                        <div className="sub-actions">
                                            <div className="checkbox-container">
                                                <input className='checkbox' type="checkbox"></input>
                                                <div className="label">Remember Me</div>
                                            </div>

                                            <div className="forgot-password label">Forgot Password?</div>
                                        </div>

                                        <div className="button-container"><button onClick={this.onClickLogin} className="btn btn-solid">Sign In</button></div>

                                        <div className="docs">
                                            <div>Privacy</div>
                                            <div>|</div>
                                            <div>Terms & Conditions</div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                    <div className="login-info">
                                        <div className="h1">Welcome Back</div>
                                        <div className="h2">If you already have an account, please sign in.</div>

                                        <div onClick={(e) => { this.toggleMode(true) }} className="button-container"><button className="btn btn-outline">Sign In</button></div>
                                    </div>
                                )
                        }

                    </div>
                    <div className="right">

                        {
                            loginActive ? (
                                <div className="signup-info">
                                    <div className="h1">Hello Friend!</div>
                                    <div className="h2">Fill up your information and start your journey with us!</div>

                                    <div onClick={(e) => { this.toggleMode(false) }} className="button-container"><button className="btn btn-outline">Sign Up</button></div>
                                </div>
                            ) : (
                                    <div className="signup-form">
                                        <div className="h1">Create New Account</div>
                                        {
                                            !showOtpForm ? (
                                                <div className="h2">or use your email to create new account</div>
                                            ) : (
                                                    <>
                                                        <div className="h2">Please enter the OTP sent to {signUpData['contactNumber']}</div>
                                                        {
                                                            !waitingForRequestOTPCall ? (
                                                                <div className="h2">
                                                                    {
                                                                        otpRemainingSeconds < 0 ? (
                                                                            <>OTP expired. <span onClick={() => { this.onClickRequestOTP(true) }} className="resend">Click Here</span> to resend OTP.</>
                                                                        ) : (
                                                                                <div className="h2">The OTP will expire in <span className="otpCountdown">{otpRemainingSeconds}s</span> seconds.</div>
                                                                            )
                                                                    }
                                                                </div>
                                                            ) : (
                                                                    <>Please wait</>
                                                                )
                                                        }
                                                    </>
                                                )
                                        }
                                        {
                                            !showOtpForm ? (
                                                <div className="form">
                                                    <div className='form-field-container'>
                                                        <div title='Required' className='field-error'></div>
                                                        <input
                                                            onChange={this.onChangeSignup}
                                                            onBlur={this.onBlurSignup}
                                                            value={signUpData['firstName'] || ''}
                                                            className={`form-field ${signUpErrors.firstName && signUpErrors.firstName.haveError ? 'invalid' : ''}`}
                                                            type="text" id="firstName"
                                                            placeholder="First Name" />
                                                    </div>
                                                    <div className='form-field-container'>
                                                        <div title='Required' className='field-error'></div>
                                                        <input
                                                            onChange={this.onChangeSignup}
                                                            onBlur={this.onBlurSignup}
                                                            value={signUpData['lastName'] || ''}
                                                            className={`form-field ${signUpErrors.lastName && signUpErrors.lastName.haveError ? 'invalid' : ''}`}
                                                            type="text"
                                                            id="lastName"
                                                            placeholder="Last Name" />
                                                    </div>
                                                    <div className='form-field-container'>
                                                        <div title='Required' className='field-error'></div>
                                                        <input
                                                            onChange={this.onChangeSignup}
                                                            onBlur={this.onBlurSignup}
                                                            value={signUpData['contactNumber'] || ''}
                                                            className={`form-field ${signUpErrors.contactNumber && signUpErrors.contactNumber.haveError ? 'invalid' : ''}`}
                                                            type="text"
                                                            id='contactNumber'
                                                            placeholder="Contact Number" />
                                                    </div>
                                                    <div className='form-field-container'>
                                                        <div title='Required' className='field-error'></div>
                                                        <input
                                                            onChange={this.onChangeSignup}
                                                            onBlur={this.onBlurSignup}
                                                            value={signUpData['email'] || ''}
                                                            className={`form-field ${signUpErrors.email && signUpErrors.email.haveError ? 'invalid' : ''}`}
                                                            type="text"
                                                            id='email'
                                                            placeholder="Email" />
                                                    </div>
                                                    <div className='form-field-container'>
                                                        <div title='Required' className='field-error'></div>
                                                        <input
                                                            onChange={this.onChangeSignup}
                                                            onBlur={this.onBlurSignup}
                                                            value={signUpData['password'] || ''}
                                                            className={`form-field ${signUpErrors.password && signUpErrors.password.haveError ? 'invalid' : ''}`}
                                                            type="password"
                                                            id='password'
                                                            placeholder="Password" />
                                                    </div>
                                                    <div className='form-field-container'>
                                                        <div title='Required' className='field-error'></div>
                                                        <input
                                                            onChange={this.onChangeSignup}
                                                            onBlur={this.onBlurSignup}
                                                            value={signUpData['areaOfInterest'] || ''}
                                                            className={`form-field ${signUpErrors.areaOfInterest && signUpErrors.areaOfInterest.haveError ? 'invalid' : ''}`}
                                                            type="text"
                                                            id='areaOfInterest'
                                                            placeholder="Area of Interest" />
                                                    </div>

                                                    <div className="sub-actions">
                                                        <div className="checkbox-container">
                                                            <input id='termsAndConditions' className='checkbox' type="checkbox"></input>
                                                            <div className="label">I have read the Terms & Conditions</div>
                                                        </div>
                                                    </div>

                                                    <div className="button-container">
                                                        {
                                                            !waitingForRequestOTPCall ? (
                                                                <button onClick={this.onClickRequestOTP} className="btn btn-solid">Request OTP</button>
                                                            ) : (
                                                                    <button className="btn btn-solid">Please wait</button>
                                                                )
                                                        }
                                                    </div>
                                                </div>
                                            ) : (
                                                    <div className="form">
                                                        <div className='form-field-container'>
                                                            <input onChange={this.onChangeOTP} value={otp} className="form-field" type="text" id="otp" placeholder="Type you OTP"></input>
                                                        </div>

                                                        <div className="button-container">
                                                            {
                                                                !waitingForSignupCall ? (
                                                                    <button onClick={this.onClickSignup} className="btn btn-solid">Sign up</button>
                                                                ) : (
                                                                        <button className="btn btn-solid">Please wait</button>
                                                                    )
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                        }
                                    </div>
                                )
                        }
                    </div>
                </div>
            </div>
        )
    }
}
